export const getUpdatedData = (formFields, value, key) => {
  const errors = {};
  const updateFormFields = { ...formFields };
  updateFormFields[key].value = value;
  errors[key] = "";

  return {
    updateFormFields,
    errors,
  };
};

export const getSubmissionData = (formFields) => {
  const fieldData = {};
  const required = {};

  for (let key in formFields) {
    const value = formFields[key].value ? formFields[key].value : "";
    const fieldValue = value;

    if (fieldValue) {
      fieldData[key] = fieldValue;
    } else if (formFields[key].elementConfigs.required) {
      required[key] = "Required";
    }
  }
  return {
    fieldData,
    required,
  };
};
